import * as Icons from "lucide-react";
import { Box } from "lucide-react";

// Dynamically resolve a lucide icon by string name.
// Falls back to Box if not found.
export default function Icon({ name, className, ...props }) {
  const C = (name && Icons[name]) || Box;
  return <C className={className} {...props} />;
}
